import React from 'react';
import { Container, Card, Row, Button } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { formatCurrency } from '../utils';
import { Spinner } from 'react-bootstrap'
import { faCar, faArchive, faFileInvoiceDollar, faHandHoldingUsd } from '@fortawesome/free-solid-svg-icons'

export default class Results extends React.Component {

    renderCell = (props) => {
        const { icon, top, bottom, note, cardClassName } = props;

        return (
            <Card className={cardClassName}>  
                <div className="justify-content-md-center text-center icon">
                    <FontAwesomeIcon icon={icon} size="4x" />
                </div>
                <div className="justify-content-md-center text-center">{top}</div>
                <div className="justify-content-md-center text-center">{bottom}</div>
                <div className="justify-content-md-center small text-center">{note}</div>
            </Card>
        );
    }

    render() {
        const { results, emailBusy, fleetPricingBusy, disabled, onFleetPricing } = this.props;

        return (
            <Card className="quote">
                <Card.Title>Quote</Card.Title>
                <Card.Body>       

                    <Container>
                        {this.renderCell({ icon: faArchive, top: `$${formatCurrency(results.total_package_cost_per_pay_cycle)}`, bottom: "Total Package Cost", note: "(Repayment and budgeted running expenses per payroll period selected)" })}
                        {this.renderCell({ icon: faFileInvoiceDollar, top: `$${formatCurrency(results.running_costs_per_pay_cycle_gross)}`, bottom: "Running Expenses Included", note: "(Fuel, servicing, tyres, insurance, registration, wash, etc per payroll period selected)" })}                                    
                        {this.renderCell({ icon: faCar, top: `$${formatCurrency(results.cost_of_car_per_pay_cycle)}`, bottom: "Cost of Car", note: "(Cost of car through vehicle salary package per payroll period selected)", cardClassName: "big" })}
                        {this.renderCell({ icon: faHandHoldingUsd, top: `$${formatCurrency(results.tax_savings)}`, bottom: "Tax Savings Achieved", note: "(GST savings on vehicle plus GST savings and income tax savings on package over lease)" })}
                    
                        <Row className="mt-3 justify-content-md-center text-center">
                            <Button onClick={onFleetPricing} disabled={disabled} className="mr-2">
                                {fleetPricingBusy &&
                                    <Spinner
                                        as="span"
                                        animation="border"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                        className="mr-2"
                                    />
                                }
                                Enquire about Fleet Pricing
                            </Button>
                        </Row>

                        <Row className="mt-3 justify-content-md-center text-center">
                            <div className="small">
                                Please note the above figures have not included a fleet discount which may further reduce the cost and increase the benefit
                            </div>
                        </Row>
                    </Container>
                </Card.Body>
            </Card>
               
        );
    }
}
